import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import { VersionsActionTypes } from '../../actions/types';

const getDataToCompareVersions = makeAsyncReducerHandlers(
  VersionsActionTypes.getDataToCompareVersions,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.versions,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addVersion = makeAsyncReducerHandlers(
  VersionsActionTypes.addVersion,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
    shouldCreateVersion: state.shouldCreateVersion,
  }),
  (state, action) => ({
    items: [...state.items, action.payload.version],
    status: RequestStatus.SUCCEEDED,
    error: null,
    shouldCreateVersion: false,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
    shouldCreateVersion: state.shouldCreateVersion,
  }),
);

const setShouldCreateVersion = (state, action) => ({
  ...state,
  shouldCreateVersion: action.payload.value,
});

const restoreVersion = makeAsyncReducerHandlers(
  VersionsActionTypes.restoreVersion,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.versions,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  getDataToCompareVersions,
  addVersion,
  setShouldCreateVersion,
  restoreVersion,
};
